import { shallowMount } from "@vue/test-utils";
import OfferGroup from "@/components/core/OfferGroup";

describe("OfferGroup component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfferGroup, {
      slots: {
        default: "<div></div>"
      }
    });
  });

  it("Renders del component OfferGroup", () => {
    expect(wrapper).toBeDefined();
  });
});
